import { render, staticRenderFns } from "./Detail-Template-New.vue?vue&type=template&id=6f5867fc&scoped=true"
import script from "./Detail-Template-New.vue?vue&type=script&lang=js"
export * from "./Detail-Template-New.vue?vue&type=script&lang=js"
import style0 from "./Detail-Template-New.vue?vue&type=style&index=0&id=6f5867fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5867fc",
  null
  
)

export default component.exports